import { useParams } from 'react-router-dom'

export function BlockCrumb() {
  const { blockId } = useParams()
  if (!blockId) throw new Error('Param blockId is required')
  return <>{blockId}</>
}
